import React, { useState, useEffect } from 'react';

import { Card, Button } from '@blueprintjs/core';
import { Toastr } from '../../../services/toastr';
import Loading from '../../../components/Loading';

const ImportData = ({ onSubmit, isLoadingFile, resetFile }) => {
  const [file, setFile] = useState({});
  const [secondFile, setSecondFile] = useState({});

  useEffect(() => {
    if (resetFile) {
      setFile({});
      setSecondFile({});
    }
  }, [resetFile]);

  const handleSelectedFile = (e, isSecondFile) => {
    e.persist();
  
    if (!e.target || e.target.files.length === 0) return;

    const type = e.target.files[0].type;
    if (type === 'application/zip') {
      if (!isSecondFile) setFile(e);
      else setSecondFile(e);
    } else {
      Toastr.show({ message: 'Invalid file format. Only .zip are allowed', intent: 'warning' });
    }
  };

  const handleSubmitFiles = () => {
    if (file) onSubmit(file);
    if (secondFile) onSubmit(secondFile);
  };

  const renderFileInput = (filesAccepted, inputPlaceHolder, isSecondFile = false) => {
    let fileName = inputPlaceHolder;

    if (!isSecondFile && file.target) fileName = file.target.files[0].name;
    else if (isSecondFile && secondFile.target) fileName = secondFile.target.files[0].name;

    return (
      <div className="settings-input-file mb-16">
        <div className="bp3-input-group mt-7">
          {isLoadingFile ? (
            <Loading />
          ) : (
            <label className="bp3-file-input bp3-fill">
              <input
                type="file"
                accept={filesAccepted}
                onChange={e => {
                  handleSelectedFile(e, isSecondFile);
                }}
              />
              <span className="bp3-file-upload-input">{fileName}</span>
            </label>
          )}
        </div>
      </div>
    );
  };

  return (
    <section>
      <Card className="section-card">
        <div className="card-body">
          <div className="row">
            <div className="col-12 card-header">
              <h4 className="card-title">Import</h4>
              <p className="card-subtitle">Import from Zip</p>
            </div>
          </div>
          <div className="row">
            <div className="settings-import">
              <div className="settings-import-input">
                {(
                  <div className="settings-input-file mb-16">
                    <div className="bp3-input-group mt-7">
                      <label className="bp3-file-input bp3-fill">
                        <input disabled type="file" />
                      </label>
                    </div>
                  </div>
                )}
                {renderFileInput('.zip', 'import: .zip')}
              </div>
              <div className="settings-import-button">
                <div className="mt-24">
                  <Button
                    disabled={!Object.keys(file || secondFile).length || isLoadingFile}
                    intent="success"
                    className="pb-button pb-button-large"
                    onClick={handleSubmitFiles}
                  >
                    {'Importar'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </section>
  );
};

export default ImportData;
